// lib
import React from 'react'
import '@aytm/lib/common/moment-duration-format'
import { Map } from 'immutable'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { formatCurrency } from '@aytm/lib/common/func'

// components
import LoaderWave from '@aytm/lib/rfd-ui/components/basic/loader-wave'

// styles
import '@aytm/lib/rfd-ui/styles/advanced/survey-estimator.scss'

// <Component>
SurveyAddonEstimator.propTypes = {
  price: PropTypes.number,
  status: PropTypes.string.isRequired, // fetching | failed | ready
  locale: PropTypes.instanceOf(Map).isRequired
}
export default React.memo(
  SurveyAddonEstimator,
  (prevProps, nextProps) =>
    prevProps.price == nextProps.price && prevProps.status == nextProps.status && prevProps.locale == nextProps.locale
)
function SurveyAddonEstimator(props, _context) {
  return (
    <div
      className={classNames('rfd-ui-survey-estimator', 'checkout-sidebar-estimator', 'rfd-ui-list-survey-estimator')}
    >
      <div className={classNames('rfd-ui-survey-estimator-data', 'list-survey')}>{renderPrice(props)}</div>
    </div>
  )
}

// loader
function renderLoader() {
  return (
    <div className="rfd-ui-survey-estimator-price-loader">
      <LoaderWave bars={20} height={20} />
    </div>
  )
}

// total price
function renderPrice(payload = {}) {
  const { price, locale, status } = payload
  return 'fetching' == status || null == price ? (
    renderLoader()
  ) : (
    <div className="rfd-ui-survey-estimator-price">
      <span>
        ${formatCurrency(price / 100).split('.')[0]}
        <span className="rfd-ui-survey-estimator-price-cents">
          .{formatCurrency(price / 100).split('.')[1] || '00'}
        </span>
      </span>
      <span className="rfd-ui-survey-estimator-price-tax-note">{0 < price ? locale.get('tax') : ''}</span>
    </div>
  )
}
